import React from 'react';
import { styled } from '@mui/material';
import { Checkbox, Stack, Text } from 'library/ui';
import { IPermission } from './models';

interface ISelectPermissionsProps {
    availablePermissions: IPermission[];
    selectedPermissions: number[];
    onPermissionSelect: (id: number) => void;
}

export default function SelectPermissions({
    availablePermissions,
    selectedPermissions,
    onPermissionSelect,
}: ISelectPermissionsProps) {
    return (
        <Stack gap="sm">
            <Text weight="semibold">Select Permissions</Text>
            {availablePermissions.map((x) => (
                <Stack key={x.id} gap="none">
                    <Checkbox
                        label={x.name}
                        checked={selectedPermissions.includes(x.id)}
                        onChange={() => onPermissionSelect(x.id)}
                    />
                    <Description>
                        <Text size="xs" tone="secondary">
                            {x.description}
                        </Text>
                    </Description>
                </Stack>
            ))}
        </Stack>
    );
}

const Description = styled('div')({
    marginLeft: 28,
});
